'use es6';

import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/esm/getPrototypeOf";
import _get from "@babel/runtime/helpers/esm/get";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import ComponentData from './ComponentData';
import GradeTypeConstants from '../../constants/GradeTypeConstants';

var RadialData = /*#__PURE__*/function (_ComponentData) {
  _inherits(RadialData, _ComponentData);

  function RadialData() {
    _classCallCheck(this, RadialData);

    return _possibleConstructorReturn(this, _getPrototypeOf(RadialData).apply(this, arguments));
  }

  _createClass(RadialData, [{
    key: "init",
    value: function init(grade) {
      _get(_getPrototypeOf(RadialData.prototype), "init", this).call(this, grade);

      this.setScore(grade);
    } // Override

  }, {
    key: "setScore",
    value: function setScore() {} // Override

  }, {
    key: "setDisplayValue",
    value: function setDisplayValue() {} // Helper

  }, {
    key: "getGoodOkBadGradeType",
    value: function getGoodOkBadGradeType(grade, goodThreshold, okThreshold) {
      if (grade < goodThreshold) {
        return GradeTypeConstants.GOOD;
      } else if (grade < okThreshold) {
        return GradeTypeConstants.OK;
      } else {
        return GradeTypeConstants.BAD;
      }
    }
  }]);

  return RadialData;
}(ComponentData);

export default RadialData;